import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../assets/styles/themes/tokens';
import FooterLegalNavigation from '../../components/login/FooterLegalNavigation';
import EmptySearchStateImage from '../../components/Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { routes } from '../../constants';
import useRouter from '../../utils/useRouter';
import useScreenSize from '../../utils/useScreenSize';

const IpRangeErrorPage: React.FC = () => {
	const { t } = useTranslation();
	const { isXsScreen, isSmScreen } = useScreenSize();
	const isSmallScreen = isXsScreen || isSmScreen;
	const { router } = useRouter();

	return (
		<Box
			sx={{
				display: 'flex',
				width: '100%',
				height: '100vh',
				justifyContent: 'center',
				alignItems: isSmallScreen ? 'center' : 'flex-start',
				paddingY: spaces.xl,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					width: '100%',
					minWidth: isXsScreen ? 'auto' : 600,
					maxWidth: isXsScreen ? '100%' : 600,
					gap: spaces.xxxl,
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: spaces.xxxl,
						width: '100%',
						alignItems: 'center',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: spaces.lg,
							width: '100%',
							paddingX: isXsScreen ? 0 : spaces.xxxxl,
						}}
					>
						<EmptySearchStateImage
							title={t('Library network required')}
							subtitle={t(
								"To log in, you need a connection to your library's network. " +
									"Please connect to the library's Wi-Fi or use your VPN connection."
							)}
							iconName="errorFlatline"
							subtitleSx={{ textAlign: 'center', maxWidth: '100%' }}
							containerSx={{ paddingBottom: 0 }}
						/>
						<Typography variant="body2" color={palette.text.secondary} sx={{ textAlign: 'center' }}>
							{t(
								'Are you no longer a library member? Change your email address to a private address ' +
									'to continue using meinUnterricht.'
							)}
						</Typography>
					</Box>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: spaces.md,
							width: '100%',
							paddingX: isXsScreen ? spaces.xxs : spaces.xxxxl,
						}}
					>
						<Button
							variant="contained"
							color="primary"
							size="large"
							fullWidth
							onClick={() => router.push(`/${routes.setNewEmail.root}`)}
						>
							{t('Change E-Mail Address')}
						</Button>
						<Typography variant="body2" sx={{ color: palette.text.primary, textAlign: 'center' }}>
							{t('or')}
						</Typography>
						<Button
							variant="text"
							color="inherit"
							size="large"
							fullWidth
							onClick={() => router.push(`/${routes.login.root}`)}
						>
							{t('Back to login')}
						</Button>
					</Box>
				</Box>
				<FooterLegalNavigation isSmallScreen={isSmallScreen} />
			</Box>
		</Box>
	);
};

export default IpRangeErrorPage;
